var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/menu/menu.tsx";
const _excluded = ["className", "position"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { Menu, MenuButton, MenuItem, MenuItems, MenuPopover, MenuLink } from '@reach/menu-button';
import { positionDefault, positionRight } from '@reach/popover';
import classNames from 'classnames';
import React from 'react';
import './menu.css';
/** Renders children as a dropdown menu. */
const MenuList = _ref => {
  let {
      className,
      position
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MenuPopover, {
    className: classNames('origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white dark:bg-slate-900 ring-1 ring-black ring-opacity-5 focus:outline-none z-[1003] dark:border dark:border-solid dark:border-slate-700', className),
    position: position === 'left' ? positionDefault : positionRight,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(MenuItems, _extends({
    onKeyDown: event => event.nativeEvent.stopImmediatePropagation(),
    className: "py-1 rounded-lg shadow-menu"
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  })));
};

/** Divides menu items. */
const MenuDivider = () => /*#__PURE__*/React.createElement("hr", {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 40,
    columnNumber: 27
  }
});
export { Menu, MenuButton, MenuDivider, MenuItems, MenuItem, MenuList, MenuLink };